import api from './api'
import { setErrors } from 'utils'

export const handleChatbot = async () => (await api.post(`/chatbots/list-by-firm`)).data

export const handleChatbotShow = async id => (await api.get(`/chatbots/${id}`)).data

export const handleChatbotStore = async (history, data, setMessages) => {
  try {
    const response = await api.post(`/chatbots/store`, data)
    return history.push(`/chatbots/${response.data.id}/update`)
  } catch (error) {
    setMessages({ messages: setErrors(error), alert: 'alert-orange' })
  }
}

export const handleChatbotUpdate = async (history, data, id, setMessages) => {
  try {
    await api.put(`/chatbots/${id}/update`, data)
    return history.push(`/chatbots`)
  } catch (error) {
    setMessages({ messages: setErrors(error), alert: 'alert-orange' })
  }
}

export const handleChatbotDelete = async (id, history) => {
  await api.delete(`/chatbots/${id}`)
  return history.push(`/chatbots`)
}

export const handleChatbotModel = async (data, id) => {
  const values = new FormData()
  values.append('file', data)
  try {
    await api.put(`/chatbots/${id}/model`, values)
    return
  } catch (error) {
    return error
  }
}